// extracted by mini-css-extract-plugin
export default {"btnn":"styles_btnn__OVIZp","btnnNo":"styles_btnnNo__ADTT9","btnnYes":"styles_btnnYes__deazR","label":"styles_label__Gf1+9","input":"styles_input__Y0ayU"};